// client/src/components/influencer/project/modals/ContractGuideModal.js
import React from 'react';

function ContractGuideModal({ open, onClose, onNext, project }) {
  if (!open || !project) return null;

  // 서비스 타입 텍스트
  const getServiceTypeText = (type) => {
    const map = {
      delivery: '배송형',
      purchase: '구매형',
      visit: '방문형',
      free: '무료 서비스'
    };
    return map[type] || type;
  };

  // 콘텐츠 타입 텍스트
  const getContentTypeText = (type) => {
    const map = {
      post: '포스트(피드)',
      video: '영상(릴스/쇼츠)',
      free: '자유'
    };
    return map[type] || type;
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* X 버튼 */}
        <button style={styles.closeBtn} onClick={onClose}>
          <span style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'block'
          }}>
            ×
          </span>
        </button>

        {/* 제목 */}
        <h2 style={styles.title}>프로젝트 정보 및 안내사항</h2>
        
        {/* 프로젝트 기본 정보 */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>📋 프로젝트 정보</div>
          <div style={styles.infoGrid}>
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>프로젝트 번호</div>
              <div style={styles.infoValue}>{project.projectNumber}</div>
            </div>
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>서비스 타입</div>
              <div style={styles.infoValue}>{getServiceTypeText(project.serviceType)}</div>
            </div>
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>콘텐츠 형식</div>
              <div style={styles.infoValue}>{getContentTypeText(project.contentType)}</div>
            </div>
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>기본 리워드</div>
              <div style={{ ...styles.infoValue, color: '#3b82f6', fontWeight: 600 }}>
                {project.rewardPointPerCreator.toLocaleString()}P
              </div>
            </div>
            {project.perPurchaseReward?.use && (
              <div style={styles.infoItem}>
                <div style={styles.infoLabel}>구매당 추가 리워드</div>
                <div style={{ ...styles.infoValue, color: '#10b981', fontWeight: 600 }}>
                  +{project.perPurchaseReward.rewardPerBuyer.toLocaleString()}P/건
                </div>
              </div>
            )}
          </div>
        </div>

        {/* 셀프애드 안내사항 */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>📢 셀프애드 안내사항</div>
          <div style={styles.guideBox}>
            <div style={styles.guideItem}>
              1. 계약 수락 후, 일정에 맞춰 콘텐츠를 업로드 해주세요.
            </div>
            <div style={styles.guideItem}>
              2. 업로드한 콘텐츠는 '결과물 제출' 메뉴에서 제출해 주세요.
            </div>
            <div style={styles.guideItem}>
              3. 광고주 승인 완료 후 리워드가 지급됩니다.
            </div>
            <div style={styles.guideItem}>
              4. 계약 내용을 준수하지 않을 경우 불이익이 있을 수 있습니다.
            </div>
            <div style={styles.guideItem}>
              5. 문의사항은 '문의하기' 메뉴를 이용해주세요.
            </div>
            <div style={styles.guideItem}>
              6. 콘텐츠를 위해 서비스 혹은 제품을 제공받고, 계약 미이행시 3배 이상의 위약금을 지불하셔야 합니다.
            </div>
          </div>
        </div>

        {/* 확인 버튼 */}
        <button style={styles.confirmBtn} onClick={onNext}>
          계약에 동의합니다
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10001
  },
  modal: {
    position: 'relative',
    background: '#fff',
    borderRadius: 12,
    padding: 32,
    maxWidth: 600,
    width: '90%',
    maxHeight: '90vh',
    overflowY: 'auto'
  },
  closeBtn: {
    position: 'absolute',
    top: 16,
    right: 16,
    background: 'none',
    border: 'none',
    fontSize: 26,
    lineHeight: '0',
    cursor: 'pointer',
    color: '#9ca3af',
    padding: '0',
    margin: '0',
    width: '32px',
    height: '32px',
    fontFamily: 'Arial, sans-serif',
    fontWeight: '300'
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 24,
    color: '#111827'
  },
  section: {
    marginBottom: 24
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 12,
    color: '#374151'
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 12
  },
  infoItem: {
    padding: 12,
    background: '#f9fafb',
    borderRadius: 8
  },
  infoLabel: {
    fontSize: 12,
    color: '#6b7280',
    marginBottom: 4
  },
  infoValue: {
    fontSize: 15,
    fontWeight: 500,
    color: '#111827'
  },
  guideBox: {
    padding: 16,
    background: '#fef3c7',
    border: '1px solid #fbbf24',
    borderRadius: 8
  },
  guideItem: {
    fontSize: 14,
    lineHeight: 1.8,
    color: '#78350f',
    marginBottom: 8
  },
  confirmBtn: {
    width: '100%',
    padding: '14px',
    background: '#10b981',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: 8
  }
};

export default ContractGuideModal;

